// Unified service for employee contract operations
import { employeeContractListService } from './services';
import { employeeContractEditService } from './services/employeeContractEdit.service';
import { employeeContractDeleteService } from './services/employeeContractDelete.service';


export class EmployeeContractService {
  // List operations
  list = employeeContractListService.list.bind(employeeContractListService);

  // Edit operations
  get = employeeContractEditService.get.bind(employeeContractEditService);
  update = employeeContractEditService.update.bind(employeeContractEditService);

  // Delete operations
  delete = employeeContractDeleteService.delete.bind(employeeContractDeleteService);
}

export const employeeContractService = new EmployeeContractService();
